import { SET_LOGOUT, CLEAR_ALL } from '../../../store/Types';

export const GETALL_CLASES_DOCENTES = 'GETALL_CLASES_DOCENTES';
export const LOADING_GETALL_CLASES_DOCENTES = 'LOADING_GETALL_CLASES_DOCENTES';
export const ACTIVO_CLASES_DOCENTES = 'ACTIVO_CLASES_DOCENTES';
export const PARAMS_CLASES_DOCENTES = 'PARAMS_CLASES_DOCENTES';

const initialState = {
  all: [],
  loadingGetAll: false,
  meta: null,
  links: null,
  activo: null,
  params: {},
};

export const clasesDocentesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_CLASES_DOCENTES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_GETALL_CLASES_DOCENTES:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case ACTIVO_CLASES_DOCENTES:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_CLASES_DOCENTES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
